import { useLayoutEffect } from 'react'
import { Outlet } from 'react-router'

import { THEME } from '../../../constants/themeMode'
import { useInitData, useLogin, useThemeMode } from '../../../hooks'
import { Loader } from '../../Loader'

function EmailRawLayout() {
  const { authorized } = useInitData()

  const { setForcedTheme } = useThemeMode()

  useLogin()

  useLayoutEffect(() => {
    setForcedTheme(THEME.light)

    return () => {
      setForcedTheme(null)
    }
  }, [])

  return authorized ? <Outlet /> : <Loader />
}

export default EmailRawLayout
